// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "portfolio" + "." + "a99d0ed4" + ".css";
};